/**
 * w1Shell feature flag helper (Story #5351 W1-T7).
 *
 * MUST be read at render time only, never at module scope: importing this
 * module must have zero side effects, because __tests__/route-manifest.test.tsx
 * imports App.tsx statically before any config stub is installed. A
 * module-scope read (`const w1 = isW1Shell()` at the top of a file) would
 * capture whatever the flag happened to be during that early import and
 * never re-check it — call isW1Shell() from inside a component body/hook.
 *
 * Sources, in priority order:
 *   1. localStorage override (`w1Shell` = "true"/"false") — for testing/CoWork,
 *      so the flag can be flipped without a deploy or config.js edit.
 *   2. window.SECUREEMBED_CONFIG.W1_SHELL — the deployed default. Undefined-safe
 *      OFF: an absent config, an absent key, or a non-boolean value all read as
 *      false, so a stale or partial config.js never accidentally turns W1 on.
 *
 * Enabling the flag as the deployed default requires a Terraform apply to
 * layer 00-dashboard's config.js generation (approval-gated per story #5351's
 * Deployment & Approval Boundary) — this helper never writes that value itself.
 */

const LOCAL_STORAGE_KEY = 'w1Shell';

export function isW1Shell(): boolean {
  try {
    const override = window.localStorage?.getItem(LOCAL_STORAGE_KEY);
    if (override === 'true') return true;
    if (override === 'false') return false;
  } catch {
    // localStorage unavailable (private browsing, SSR-like test env) — fall through.
  }
  return window.SECUREEMBED_CONFIG?.W1_SHELL === true;
}
